module.exports = __webpack_public_path__ + "img/index1.262f845f.png";